export default {
  state: {
    currentMenu: 'series',
    menuFold: false,
  },
  getters: {
    menus: ({ menus, soul }) => {
      return Object.values(soul).filter(item => !item.hideInEditor)
    },
    currentMenu: ({ currentMenu }) => currentMenu,
    menuFold: ({ menuFold }) => menuFold,
  },
  actions: {
  },
  mutations: {
    setMenus (state, val) {
      state.menus = val
    },
    setCurrentMenu (state, val) {
      state.currentMenu = val
    },
    setMenuFold (state, val) {
      state.menuFold = val
    }
  }
}
